<template>
  <div class="plan">
    <Header></Header>
      <div class="plan-banner flex-row">
        <div class="container business-banner-title">
          <p>产业赋能服务</p>
          <p>
            18万+企业一把手
          </p>
          <p>国内最大的产业生态圈星友会</p>
        </div>
      </div>
      <div class="plan-research" :style="'background:url('+require('@/assets/images/business/research'+(research+1)+'-bg.png')+')'">
        <p class="plan-title">专注产业研究  智力赋能产业</p>
        <div class="container">
          <div class="flex-row">
            <div class="research-item flex-row" v-for="(i,index) in researchList" :key="index" @click="research=index" :class="research==index?'research-active':''">
                <img :src="research==index?require('@/assets/images/business/'+i.img+'-active.png'):require('@/assets/images/business/'+i.img+'.png')" alt="">&emsp;{{i.name}}
            </div>
          </div>
          <p class="plan-intro" v-if="research==0">
              根据当地综合优势、经济发展阶段及产业的运行特点，科学选择主导产业，谋划产业生态。
          </p>
          <p class="plan-intro" v-else-if="research==1">
              设计园区治理机制和管理结构，制定相应的园区运营模式，形成战略规划文件。
          </p>
          <p class="plan-intro" v-else-if="research==2">
              全面梳理当地产业发展的基础条件，制定精准产业招商地图和招商策略，实现补链固链强链。
          </p>
          <p class="plan-intro" v-else-if="research==3">
              根据宏观环境和相关政策，分析目标企业的行业发展趋势，对目标企业开展全面分析调研。 
          </p>
        </div>
      </div>
      <div class="plan-expert">
          <p>专家领衔研究团队</p>
          <p>中产智库聚集各行业专家学者，与上海社会科学院、上海市工业经济联合会、上</p>
          <p>海现代服务业联合会等顶级机构合作，以专业研究团队提供产业智力服务。</p>
      </div>
      <div class="plan-case">
          <p class="plan-case-title">服务案例</p>
          <div class="container flex-row case-list">
              <div class="case-item" :class="currentCase==0?'case-active':''" @mouseover="currentCase=0" :style="'background-image:url('+require('@/assets/images/business/case1-bg.png')">
                <div>
                    <div class="case-title">产业规划</div>
                    <p>广西自贸区崇左片区“十四五”产业发展规划</p>
                    <p>中国-东盟跨境电子信息产业链专项研究</p>
                    <p>宝清县战略支柱产业规划优化方案</p>
                    <p>金山区制造业高质量发展“十四五”规划</p>
                    <p>上海吴泾老工业基地产业升级战略定位研究</p>
                    <p>浦东新区数字赋能产业高质量发展研究报告</p>
                </div>
              </div>
              <div class="case-item" :class="currentCase==1?'case-active':''" @mouseover="currentCase=1" :style="'background-image:url('+require('@/assets/images/business/case2-bg.png')">
                <div>
                  <div class="case-title">招商咨询</div>
                  <p>衡水市产业招商地图</p>
                  <p>张江人工智能招商咨询报告</p>
                  <p>将乐县绿色涂料及化工新材料产业链招商规划</p>
                  <p>内蒙古巴彦淖尔市五原县产业发展规划</p>
                </div>
              </div>
              <div class="case-item" :class="currentCase==2?'case-active':''" @mouseover="currentCase=2" :style="'background-image:url('+require('@/assets/images/business/case3-bg.png')">
                <div>
                  <div class="case-title">区域发展</div>
                  <p>金山区民营经济发展报告（2022年版）</p>
                  <p>上海世博地区发展报告（2017-2018）</p>
                  <p>上海吴淞园区转型升级策略咨询报告</p>
                  <p>杨浦滨江 15.5 公里发展功能定位研究</p>
                </div>
              </div>
              <div class="case-item" :class="currentCase==3?'case-active':''" @mouseover="currentCase=3" :style="'background-image:url('+require('@/assets/images/business/case4-bg.png')">
                <div>
                  <div class="case-title">专项研究</div>
                  <p>区域经济深度转型下平台经济发展与税收管理创新研究</p>
                  <p>上海应急物资生产供应保障制度体系建设研究</p>
                  <p>SKU 自动物流配送中心建设项目推广应用研究</p>
                  <p>创建上海现代进出口食品冷链公共综合服务平台研究</p>
                </div>
              </div>
          </div>
      </div>
    <Footer></Footer>
  </div>
</template>

<script>
import "@/assets/css/plan.css";
import Header from './Header'
import Footer from './Footer'
export default {
  name: "Plan",
  components:{
    Header,Footer
  },
  data() {
    return {
      research:0,
      researchList:[
        {name:'产业规划',img:'research1'},
        {name:'园区升级',img:'research2'},
        {name:'产业图谱',img:'research3'},
        {name:'项目尽调',img:'research4'}
      ],
      currentCase:0
      };
  },
  created(){
  },
  mounted() {
    var wow = new this.$wow.WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 200,
      mobile: false,
      live: true
    });
    wow.init();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Plan.vue